<template>
    <div class="qzsy-table-container">
        <table class="qzsy-table">
            <thead>
                <tr>
                    <th class="col-dizhi">地支</th>
                    <th class="col-gongwei">宫位</th>
                    <th class="col-shensha">神煞</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data" :key="index">
                    <td class="col-dizhi">{{ item[0] || '' }}</td>
                    <td class="col-gongwei">{{ item[1] || '' }}</td>
                    <td class="col-shensha multi-line">{{ item[2] || '' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    data: {
        type: Array,
        default: () => []
    }
})
</script>

<style scoped>
.qzsy-table-container {
    color: white;
    /* 全局白色字体 */
}

.qzsy-table {
    width: 100%;
    border-collapse: collapse;
    color: white;
    /* 表格文字白色 */
}

.qzsy-table th,
.qzsy-table td {
    padding: 10px 8px;
    border: 1px solid #444;
}

/* 列样式设置 */
.col-dizhi {
    width: 100px;
    text-align: center;
    /* 地支列居中 */
}

.col-gongwei {
    width: 120px;
    text-align: center;
    /* 宫位列居中 */
}

.col-shensha {
    text-align: left;
    /* 神煞列左对齐 */
}

.multi-line {
    white-space: pre-line;
    /* 保留换行 */
    padding-left: 12px;
    /* 左侧内边距 */
}

/* 表头样式 */
.qzsy-table th {
    background-color: #33334d;
    font-weight: bold;
    color: #b0a0ff;
    /* 表头淡紫色 */
}

/* 表格行样式 */
.qzsy-table tr:nth-child(even) {
    background-color: rgba(40, 40, 60, 0.5);
    /* 偶数行背景 */
}

.qzsy-table tr:nth-child(odd) {
    background-color: rgba(30, 30, 45, 0.5);
    /* 奇数行背景 */
}

.qzsy-table tr:hover {
    background-color: rgba(110, 90, 210, 0.2);
    /* 悬停效果 */
}
</style>